const ClockLight = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <circle
      data-name="layer2"
      cx="32"
      cy="32"
      r="30"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="6"
      strokeLinejoin="round"
    ></circle>
    <path
      data-name="layer1"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="6"
      d="M32 10v23l13 7"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export default ClockLight;
